import { render, staticRenderFns } from "./SyllabusFill.vue?vue&type=template&id=7f6d5916&"
import script from "./SyllabusFill.vue?vue&type=script&lang=js&"
export * from "./SyllabusFill.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusFill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports